/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{createVisualElements as e}from"./lineObjectVisualElementUtils.js";import{manipulatedObjectGeometry as t}from"./manipulatedObjectUtils.js";import{createVisualElements as s}from"./originGeometryVisualElementUtils.js";function l(l){switch(t(l.object)?.type){case"point":case"mesh":return s(l);case"polygon":case"polyline":return e(l);default:return null}}export{l as createVisualElements};
